import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Close } from '@next-common/material-ui-icons';
import { colorPalette } from '../../../colorPalette';
export const DrawerHeader = ({ title, titlePosition = 'center', subTitle, onClose, width, iconWidth, iconHeight }) => {
    return (React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: {
            backgroundColor: 'white',
            position: 'fixed',
            width: width || '100%',
            height: {
                xs: '56px',
                md: '72px',
            },
            zIndex: 999,
            borderTopRightRadius: {
                xs: '16px',
                md: 0,
            },
            borderTopLeftRadius: {
                xs: '16px',
                md: 0,
            },
            padding: {
                xs: '24px 16px',
                md: '16px 24px',
            },
            borderBottom: `1px solid ${colorPalette.gray200}`,
        } },
        React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: {
                width: '100%',
                height: '25px',
            } },
            subTitle ? (React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center" },
                React.createElement(Typography, { sx: {
                        fontSize: '18px',
                        fontWeight: '600',
                        color: colorPalette.gray800,
                    } }, title),
                React.createElement(Typography, { sx: {
                        fontSize: '14px',
                        fontWeight: '400',
                        color: colorPalette.gray600,
                    } }, subTitle))) : (React.createElement(Stack, { sx: {
                    width: '100%',
                }, justifyContent: "center", alignItems: titlePosition === 'center' ? 'center' : titlePosition === 'start' ? 'flex-start' : 'flex-end' },
                React.createElement(Typography, { sx: {
                        fontSize: '18px',
                        fontWeight: '600',
                        color: colorPalette.gray800,
                    } }, title))),
            React.createElement(IconButton, { onClick: onClose },
                React.createElement(Close, { sx: Object.assign(Object.assign({ stroke: colorPalette.gray500, strokeWidth: 1, color: colorPalette.gray500 }, (iconWidth && { width: iconWidth })), (iconHeight && { height: iconWidth })) })))));
};
